export const getFullscreenElement = () => {
   if (typeof document === 'undefined') return null;

   return document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement ||
      (document.webkitIsFullScreen ? document.documentElement : null);
};

export const isFullscreen = () => Boolean(getFullscreenElement());

export const isFullscreenSupported = (element) => {
   if (typeof document === 'undefined') return false;

   const target = element || document.documentElement;
   if (!target) return false;

   const requestFullscreenFn = target.requestFullscreen ||
      target.webkitRequestFullscreen ||
      target.mozRequestFullScreen ||
      target.msRequestFullscreen;
   const fullscreenEnabled = document.fullscreenEnabled ??
      document.webkitFullscreenEnabled ??
      document.mozFullScreenEnabled ??
      document.msFullscreenEnabled;

   return Boolean(requestFullscreenFn) && fullscreenEnabled !== false;
};

export const shouldUseFullscreenFallback = () => {
   if (typeof navigator === 'undefined') return false;

   const userAgent = navigator.userAgent || '';
   const platform = navigator.platform || '';
   const maxTouchPoints = navigator.maxTouchPoints || 0;

   return /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent) ||
      (platform === 'MacIntel' && maxTouchPoints > 1);
};

export const requestFullscreen = (element) => {
   const target = element || (typeof document !== 'undefined' ? document.documentElement : null);

   if (!target) {
      return Promise.reject(new Error('Fullscreen target is not available.'));
   }

   const requestFullscreenFn = target.requestFullscreen ||
      target.webkitRequestFullscreen ||
      target.mozRequestFullScreen ||
      target.msRequestFullscreen;

   if (!requestFullscreenFn) {
      return Promise.reject(new Error('Fullscreen is not supported by this browser.'));
   }

   try {
      const result = requestFullscreenFn.call(target);
      return result && typeof result.then === 'function' ? result : Promise.resolve();
   } catch (error) {
      return Promise.reject(error);
   }
};

export const exitFullscreen = () => {
   if (!getFullscreenElement()) {
      return Promise.resolve();
   }

   const exitFullscreenFn = document.exitFullscreen ||
      document.webkitExitFullscreen ||
      document.mozCancelFullScreen ||
      document.msExitFullscreen;

   if (!exitFullscreenFn) {
      return Promise.resolve();
   }

   const result = exitFullscreenFn.call(document);
   return result && typeof result.then === 'function' ? result : Promise.resolve();
};
